















import { Component, Watch, Vue } from 'vue-property-decorator'
import VueMarkdown from 'vue-markdown'

import authModule from '@/store/auth'
import Navbar from '@/components/Navbar.vue'

@Component({
  name: 'MarkdownView',
  components: {
    VueMarkdown,
    Navbar
  }
})
class MarkdownView extends Vue {
  private content = ''

  private get pageTitle(): string {
    if (typeof this.$route.meta?.title === 'string') {
      return this.$route.meta?.title
    }

    return ''
  }

  private get isLoggedIn(): boolean {
    return authModule.isLoggedIn
  }

  @Watch('$route.path')
  private onRouteChanged(): void {
    // This hack is necessary to keep the content up to date
    // while reusing the component
    this.fetchPage()
  }

  private created(): void {
    this.fetchPage()
  }

  private fetchPage(): void {
    try {
      this.content = require(`@/pages${this.$route.path}.md`).default
    } catch (error) {
      this.$router.push({ name: 'HomeView' })
    }
  }
}

export default MarkdownView
